import { type InputHTMLAttributes, forwardRef } from 'react';
import { formStyles } from '@utils/formStyles';

interface FormTimeInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: string;
    error?: string;
    helpText?: string;
    fullWidth?: boolean;
    noMargin?: boolean;
}

const FormTimeInput = forwardRef<HTMLInputElement, FormTimeInputProps>(
    ({ label, error, helpText, fullWidth = true, noMargin = false, className = '', ...rest }, ref) => {
        const inputClasses = `${error ? formStyles.inputError : formStyles.input} ${formStyles.placeholder} ${className}`;
        let containerClasses;

        if (noMargin) {
            containerClasses = fullWidth ? formStyles.fullWidthContainerNoMargin : formStyles.containerNoMargin;
        } else {
            containerClasses = fullWidth ? formStyles.fullWidthContainer : formStyles.container;
        }

        return (
            <div className={containerClasses}>
                {label && (
                    <label className={formStyles.label} htmlFor={rest.id}>
                        {label}
                    </label>
                )}
                <input className={inputClasses} ref={ref} type="time" {...rest} />
                {helpText && <div className={formStyles.helpText}>{helpText}</div>}
                {error && <div className={formStyles.errorText}>{error}</div>}
            </div>
        );
    }
);

FormTimeInput.displayName = 'FormTimeInput';

export default FormTimeInput;
